<template>
  <div class="full_layout market" v-loading.fullscreen="loading">
    <el-form :model="registrierForm" :rules="rules" ref="ruleForm">
      <div class="flex_display from_list">
        <div class="flex_one">
          <span class="title">Basic Information</span></div>
        <div class="from_box">
          <div class="grid grid-template2 gap">
            <el-form-item class="login_form_item" prop="title">
              <div class="login_title">Title</div>
              <el-input class="login_ipt" v-model="registrierForm.title" placeholder="Please enter Title"></el-input>
            </el-form-item>
            <div></div>
          </div>
          <div class="grid grid-template2 gap">
            <el-form-item class="login_form_item" prop="firstName">
              <div class="login_title required">First Name</div>
              <el-input class="login_ipt" v-model="registrierForm.firstName" placeholder="Please enter First Name"></el-input>
            </el-form-item>
            <el-form-item class="login_form_item" prop="lastName">
              <div class="login_title required">Last Name</div>
              <el-input class="login_ipt" v-model="registrierForm.lastName" placeholder="Please enter Last Name"></el-input>
            </el-form-item>
          </div>
          <div class="grid grid-template2 gap">
            <el-form-item class="login_form_item" prop="companyName">
              <div class="login_title required">Company Name</div>
              <el-input class="login_ipt" v-model="registrierForm.companyName" placeholder="Please enter Company Name"></el-input>
            </el-form-item>
            <el-form-item class="login_form_item" prop="vatId">
              <div class="login_title required">VAT ID</div>
              <el-input class="login_ipt" v-model="registrierForm.vatId" placeholder="Please enter VAT ID"></el-input>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="flex_display from_list">
        <div class="flex_one">
          <span class="title">Company Address</span></div>
        <div class="from_box">
          <div class="grid grid-template2 gap">
            <el-form-item class="login_form_item" prop="street">
              <div class="login_title required">Street</div>
              <el-input class="login_ipt" v-model="registrierForm.street" placeholder="Please enter Street"></el-input>
            </el-form-item>
            
            <el-form-item class="login_form_item" prop="houseNumber">
              <div class="login_title required">House Number</div>
              <el-input class="login_ipt" v-model="registrierForm.houseNumber" placeholder="Please enter House Number"></el-input>
            </el-form-item>
          </div>
          <div class="grid grid-template2 gap">
            <el-form-item class="login_form_item" prop="addressLine">
              <div class="login_title">Address Line 2</div>
              <el-input class="login_ipt" v-model="registrierForm.addressLine" placeholder="Please enter Address Line"></el-input>
            </el-form-item>
            <el-form-item class="login_form_item" prop="postalCode">
              <div class="login_title required">Postal Code</div>
              <el-input class="login_ipt" v-model="registrierForm.postalCode" placeholder="Please enter Postal Code"></el-input>
            </el-form-item>
          </div>
          <div class="grid grid-template2 gap">
            <el-form-item class="login_form_item" prop="country">
              <div class="login_title required">Country / Region</div>
              <el-select v-model="registrierForm.country" placeholder="Please select Country / Region" style="width:100%" @change="nationChange">
                <el-option v-for="item in nationList" :key="item._id" :label="item.EnName" :value="item.EnName">
                  <!-- <div>
                  <img :src="item.IconUrl"/>{{item.EnName}}
                  </div> -->
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="login_form_item" prop="arrayCity">
              <div class="login_title required">State{{registrierForm.arrayCity}}</div>
              <el-cascader class="login_ipt" popper-class="provinceList" separator=" " style="width:100%" placeholder="Please select State" v-model="registrierForm.arrayCity" :options="provinceList"></el-cascader>
            </el-form-item>
          </div>
          
          <div class="grid grid-template2 gap">
            <el-form-item class="login_form_item" prop="city">
              <div class="login_title">City</div>
              <el-input class="login_ipt" v-model="registrierForm.city" placeholder="Please select City"></el-input>
            </el-form-item>
            <div></div>
          </div>
        </div>
      </div>
      <div class="flex_display from_list">
        <div class="flex_one"><span class="title">Contact Details</span></div>
        <div class="from_box">
          <div>
            <el-form-item class="login_form_item" prop="email">
              <div class="login_title required">Email</div>
              <el-input class="login_ipt" v-model="registrierForm.email" placeholder="Please enter Email"></el-input>
            </el-form-item>
          </div>
          <div class="grid grid-template2 gap">
            <el-form-item class="login_form_item" prop="phoneNumber">
              <div class="login_title required">Phone Number</div>
              <el-input class="login_ipt" v-model="registrierForm.phoneNumber" placeholder="Please enter Phone Number">
                <template slot="prepend">{{registrierForm.nationCode}}</template>
                
              </el-input>
            </el-form-item>
            <el-form-item class="login_form_item" prop="mobilePhone">
              <div class="login_title">Mobile Phone</div>
              <el-input class="login_ipt" v-model="registrierForm.mobilePhone" placeholder="Please enter Mobile Phone"></el-input>
            </el-form-item>
          </div>
          <div class="grid grid-template2 gap">
            <el-form-item class="login_form_item" prop="website">
              <div class="login_title">Website / Shop Link</div>
              <el-input class="login_ipt" v-model="registrierForm.website" placeholder="Please enter Website / Shop Link"></el-input>
            </el-form-item>
            <div></div>
          </div>
        </div>
      </div>
      <div class="flex_display from_list">
        <div class="flex_one"><span class="title">Business Information</span></div>
        <div class="from_box">
          <div>
            <el-form-item class="login_form_item" prop="industry">
              <div class="login_title required">Industry</div>
              <el-select v-model="registrierForm.industry" placeholder="Please select Industry" style="width:100%">
                <el-option v-for="(item,index) in industrySelect" :key="index" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <template v-if="showOther">
            <div class="grid grid-template2 gap">
              <el-form-item class="login_form_item" prop="specify">
                <div class="login_title">Please specify</div>
                <el-input class="login_ipt" v-model="registrierForm.specify" placeholder=""></el-input>
              </el-form-item>
              <div></div>
            </div>
            <div>
              <el-form-item class="login_form_item" prop="range">
                <div class="login_title">Product Range</div>
                <el-select v-model="registrierForm.range" multiple placeholder="Please select Product Range" style="width:100%">
                  <el-option v-for="(item,index) in productRange" :key="index" :label="item.label" :value="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div>
              <el-form-item class="login_form_item" prop="interest">
                <div class="login_title">Products of Interest</div>
                <el-select v-model="registrierForm.interest" multiple placeholder="Please select Products of Interest" style="width:100%">
                  <el-option v-for="(item,index) in productInterest" :key="index" :label="item.label" :value="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </template>
        </div>
      </div>
      <div class="flex_display from_list">
        <div class="flex_one"><span class="title">Business Volume</span></div>
        <div class="from_box">
          <div>
            <el-form-item class="login_form_item" prop="volume">
              <div class="login_title required">Estimated Annual Purchase Volume with Us (€) </div>
              <el-select v-model="registrierForm.volume" placeholder="Please select Estimated Annual Purchase Volume" style="width:100%">
                <el-option v-for="(item,index) in volume" :key="index" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="flex_display from_list">
        <div class="flex_one"><span class="title">Account Setup</span></div>
        <div class="from_box">
          <div class="grid grid-template2 gap">
            <el-form-item class="login_form_item" prop="password">
              <div class="login_title required">Password</div>
              <el-input class="login_ipt" show-password v-model="registrierForm.password" placeholder="Please enter Password"></el-input>
            </el-form-item>
            <el-form-item class="login_form_item" prop="confirmpassword">
              <div class="login_title required">Confirm Password</div>
              <el-input class="login_ipt" show-password v-model="registrierForm.confirmpassword" placeholder="Please enter password again"></el-input>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
    <div style="margin-top: 18px;text-align: right;">
    <el-checkbox v-model='checked' class="top" label="Remember me" name="type">
            <div class="userText">By signing in, you agree to the <router-link :to="{path:'/useragreement'}" target='_blank'>Terms of Service</router-link> and <router-link :to="{path:'/privacyagreement'}"  target='_blank'>Privacy Policy</router-link>
            </div>
          </el-checkbox>
        </div>
        <div class="from_list_btn">
          <el-button class="login_btn"  type="primary" @click="submitForm('ruleForm')">Confirm</el-button>
        </div>
  </div>
</template>
<script>
import { getarea } from "@/api/area";
import { countries } from "@/api/public";
export default {
  name: 'registrieren',
  data() {
    return {
      checked:false,
      loading: false,
      nationList:'',
      provinceList:[],
      registrierForm: {
        nationCode:'20',
        title: '',
        firstName: '',
        lastName: '',
        companyName: '',
        vatId: '',
        street: '',
        houseNumber: '',
        addressLine: '',
        postalCode: '',
        city: '',
        province:'',
        arrayCity:'',
        country: 'Germany',
        email: '',
        phoneNumber: '',
        mobilePhone: '',
        website: '',
        industry: '',
        specify:'',
        range:'',
        interest:'',
        volume:'',
        password:'',
        MemberSource:'DE',
        confirmpassword:''
      },
      industrySelect: this.$enumInfo.industry,
      productRange: this.$enumInfo.productRange,
      productInterest: this.$enumInfo.productInterest,
      volume: this.$enumInfo.volume
    }
  },
  computed: {
    rules() {
      const rules = this.setBaseRules();
      if (this.registrierForm.industry === 'other') {
        rules['range'] = [{ required: true, message: 'Please select Product Range', trigger: 'change' }];
        rules['interest'] = [{ required: true, message: 'Please select Products of Interest', trigger: 'change' }];
      }
      return rules
    },
    showOther() {
      return this.registrierForm.industry.toLowerCase() === 'other';
    }
  },
  watch: {
    // A变化时，如果B隐藏了，清空B的值并清除验证
    'registrierForm.industry'(newVal) {
      if (newVal !== 'other') {
        this.registrierForm.range = '';
        this.registrierForm.interest = '';
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate('interest');
          this.$refs.ruleForm.clearValidate('range');
        });
      }
    }
  },
  mounted() {
   },
  created() {

    this.getNationList()
  },
  methods: {
    setBaseRules(){
      const that = this;
      const rules = {
        firstName: [{ required: true, message: 'Please enter First Name', trigger: 'blur' }],
        lastName: [{ required: true, message: 'Please enter Last Name', trigger: 'blur' }],
        companyName: [{ required: true, message: 'Please enter Company Name', trigger: 'blur' }],
        vatId: [{ required: true, message: 'Please enter VAT ID', trigger: 'blur' }],
        street: [{ required: true, message: 'Please enter Street', trigger: 'blur' }],
        houseNumber: [{ required: true, message: 'Please enter House Number', trigger: 'blur' }],
        postalCode: [{ required: true, message: 'Please enter Postal Code', trigger: 'blur' }],
        arrayCity: [{ required: true, message: 'Please enter State', trigger: 'change' }],
        city: [{ required: true, message: 'Please enter City', trigger: 'blur' }],
        country: [{ required: true, message: 'Please select Country / Region', trigger: 'change' }],
        email: [
          { required: true, message: 'Please enter Email', trigger: 'blur' },
          { type: 'email', message: 'Invalid email. Please check and try again.', trigger: ['blur','change'] },
        ],
        phoneNumber: [{ required: true, message: 'Please enter Phone Number', trigger: 'blur' }],
        industry: [{ required: true, message: 'Please select Industry', trigger: 'change' }],
        volume: [{ required: true, message: 'Please select Estimated Annual Purchase Volume', trigger: 'change' }],
        password: [{ required: true, message: 'Please enter password', trigger: 'blur' },
        
        { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{6,20}$/, message: 'Password must be 6-20 characters and contain uppercase, lowercase, numbers, and special characters.',trigger: 'blur'},
      ],
      //"/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z\x21-\x7e]{6,20}$/" //6-20 位，必须包含大写、小写、数字
      //"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{6,20}$/" //6-20 位，必须包含大写、小写、数字、特殊字符
      //"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{6,20}$/" //6-20 位，必须包含大写、小写、数字、特殊字符只允许 !@#$%^&*
        confirmpassword: [
          { required: true, message: 'Please enter password again', trigger: 'blur' },
          {validator:function(rule, value, callback){
            if(!value){
              callback(new Error('Please enter password again'));
            }
            if(value!=that.registrierForm.password){
              callback(new Error('The new password entered twice is incorrect'));
            }
            callback()
          }, trigger: ['blur','change']}
        ],
      }
      return rules
    },
    getNationList() {
      let that = this;
      this.$get(this.$interface.GetNationList).then(async res => {
        that.nationList = countries(res) 
        this.provinceFn(this.registrierForm.country)
        
      })
    },
    async provinceFn(val){
      let that=this
      // 标记当前请求的国家代码
      that.nationList.map(res=>{
        if(res.EnName==val){
          that.registrierForm.MemberSource=res.Code
          that.registrierForm.nationCode=res.NationCode
        }
      })
      that._currentCountryCode = val
      that.registrierForm.arrayCity='';
      that.provinceList=[]
      if(val==='China'){
        return that.getChinaAreas()
      }else{
        return that.getOtherAreas(that.registrierForm.MemberSource)
      }
      
    },
    getChinaAreas(){
      let that=this
      const currentCode = that._currentCountryCode
      that.$get(that.$interface.GetChinaAreas,'').then(res=>{
        // 检查是否是最新的请求
        if(that._currentCountryCode !== currentCode) return
        if(res.Result==1){
          that.provinceList=getarea(res.Data) || []
        }else{
              that.$message.error(res.Msg);
            }

      })
    },
    getOtherAreas(code){
      let that=this
      const currentCode = that._currentCountryCode
      let data = { code: code }
      that.$get(that.$interface.GetAreas,data).then(res=>{
        // 检查是否是最新的请求
        if(that._currentCountryCode !== currentCode) return
        if(res.Result){
          that.provinceList=getarea(res.Data) || []
        }else{
          that.$message.error(res.Msg);
        }
      })
    },
    nationChange(e){
      let that=this
      that.provinceFn(e)
    },
    submitForm(formName) {
      let that = this;

      that.$refs[formName].validate((valid) => {
        if (valid) {
          let data=that.registrierForm
          data.Code=data.MemberSource
          data.NickName=data.firstName+data.lastName
          data.addressLine2=data.addressLine
          data.pleaseSpecify=data.specify
          data.productRange=data.range
          data.productsOfInterest=data.interest
          data.estimatedAnnualPurchaseVolume=data.volume
          data.province=data.country==='China'?data.arrayCity[0]+' '+data.arrayCity[1]+' '+data.arrayCity[2]:data.arrayCity[0]

          
          if (that.checked) {
            that.loading=true
            that.$post(that.$interface.Register, data).then(res => {
              if (res.Result != 0) {
                
                  this.$alert('Pending backend confirmation. We will contact you as soon as possible.', 'Hint', {
                    confirmButtonText: 'Ok',
                    callback: action => {
                          window.location.href = "/";
                    }
                  });
                } else {
                  that.$message.error(res.Msg);
                  that.loading=false
                }
            })
          }else{
            that.$message.error('Please agree to the terms');
          }
        }
      })
    }

  }
}

</script>
<style scoped>
.from_list{
  border-bottom: 1px solid #ccc;
  padding:20px 0;
}
.from_list .title{
  font-size: 16px;
  line-height: 2.5;
}
.from_box{
  width:60%
}
.from_list_btn{
  margin-top: 20px;
  text-align: right;
}
.userText a {
    color: var(--color-primary);
}
.required::after{
  content: "*";
  color: #f00;
  margin-left: 3px;
}

</style>



// WEBPACK FOOTER //
// src/pages/user/registrieren.vue